import { data } from '../../svg/Globe/data';
import { makeIcon } from '../makeIcon';

export const Globe = makeIcon(data, 'globe', 'Globe');

export default Globe;
